module.exports = __webpack_public_path__ + "static/img/award2.2ae3724.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award2.png
// module id = zA+0
// module chunks = 7